import React from 'react';
import './seat-map.scss';
import {TransformComponent, TransformWrapper} from 'react-zoom-pan-pinch';
import useWindowDimensions from '../../../useWindowDimentions';
import {graphql, useLazyLoadQuery, usePaginationFragment} from 'react-relay/hooks';
import {FetchKeyStateContext} from '../../../components/FetchKey';
import {MapActions, Seat} from './seat-map';

const SECTORS = {
    '1': React.lazy(() => import('./sector-1.js')),
    '2': React.lazy(() => import('./sector-2.js')),
    '3': React.lazy(() => import('./sector-3.js')),
    '4': React.lazy(() => import('./sector-4.js')),
    '5': React.lazy(() => import('./sector-5.js')),
    '6': React.lazy(() => import('./sector-6.js')),
    '7': React.lazy(() => import('./sector-7.js')),
    '8': React.lazy(() => import('./sector-8.js'))
};


const SectorSeatMap = ({localCartState, map, priceCategories, seatMapClickHandler, showInitialMap}) => {
    const {windowDimensions: {windowWidth}} = useWindowDimensions();
    const initialScale = windowWidth < 768 ? map.initialScale.mobile : map.initialScale.desktop;
    // const scale = initialWidth < 768 ? 0.88 : 0.56;
    // const shorterScreenSide = initialWidth < initialHeight ? initialWidth : initialHeight;
    // const longerAxis = parseFloat(map.width) > parseFloat(map.height) ?  parseFloat(map.width) : parseFloat(map.height);
    // const initialScale = shorterScreenSide * scale / longerAxis;
    
    return(
        <div className='seat-map seat-map--sector'>
            <div className='padding-top-1rem padding-bottom-1rem mw768-padding-bottom-2rem mw768-padding-top-1dot5rem display-grid gap-1rem-1rem price-grid'>
                {priceCategories.map((price, index) =>
                    <div key={index} className='display-flex align-items-center'>
                        <div className={`seat seat--price pointer-events-none seat--color-${index}`}></div>
                        <p className='padding-left-0dot5rem text-md color-gray-200 white-space-nowrap'>{price} ₴</p>
                    </div>
                )}
            </div>
            <div className='seat-map-container padding-top-1dot5rem'>
                <div className='margin-0-auto position-relative seat-map-container__scaling' onClick={seatMapClickHandler}>
                    <TransformWrapper {...{minScale: 0.1, maxScale: 1, centerZoomedOut: true, centerOnInit: true, initialScale, doubleClick: {disabled: true}}}>
                        <MapActions {...{showInitialMap, initialScale}}/>
                        <TransformComponent wrapperClass='seat-map-container__scaling'>
                            <svg className='display-block margin-0-auto malevich-concert-arena-seats position-relative' width={map.width} height={map.height} fill="none" xmlns="http://www.w3.org/2000/svg">
                                {!!map.static && map.static}
                                {
                                    Object.keys(map.seats).map((rowName, rowIndex) =>
                                        map.seats[rowName].map(({x, y, rx, transform, width, height, endpoint, svgTag, d, allowMultipleBuy}, seatIndex) =>
                                            <Seat key={`${rowIndex}-${seatIndex}`} {...{endpoint, localCartState, priceCategories, x, y, rx, transform, width, height, svgTag, d, allowMultipleBuy, row: rowIndex, seat: seatIndex, mirrorSeatNumbers:  map.mirrorSeatNumbers}}/>
                                        )
                                    )
                                }
                                <g className="pointer-events-none">
                                    {!!map.staticTexts && map.staticTexts}
                                </g>
                            </svg>
                        </TransformComponent>
                    </TransformWrapper>
                </div>
            </div>
        </div>
    )
};

export const SectorData = ({sectorName, serviceId, map, children}) => {
    const fetchKeyState = React.useContext(FetchKeyStateContext);
    const [priceCategories, setPriceCategories] = React.useState([]);
    const {viewer} = useLazyLoadQuery(
        graphql`
            query sectorMapPalacSportuFancyPagesViewerQuery($first: Int!, $after: String, $tagsSection: String, $serviceId: String, $available: Boolean) {
                viewer {
                    ...sectorMapPalacSportuFancyPagesViewer_viewer
                }
            }
        `,
        {first: 100500, serviceId, tagsSection: sectorName, available: true},
        {fetchKey: fetchKeyState}
    );
    const {data, loadNext, hasNext, isLoadingNext} = usePaginationFragment(
        graphql`
            fragment sectorMapPalacSportuFancyPagesViewer_viewer on Viewer @refetchable(queryName: "sectorMapPalacSportuFancyPagesSearchEndpointsQuery") {
                searchEndpoints(first: $first, after: $after, tagsSection: $tagsSection, serviceId: $serviceId, available: $available) @connection(key: "sectorMapPalacSportu_searchEndpoints") {
                    edges {
                        node {
                            id
                            labels
                            quantity
                            price
                        }
                    }
                }
            }
        `,
        viewer
    );
    data.searchEndpoints.edges.map(e => e.node).forEach((item) => {
        if (item.labels.section === sectorName && item.labels.row && item.labels.seat && map.seats && map.seats[item.labels.row] && map.seats[item.labels.row][item.labels.seat - 1]) {
            map.seats[item.labels.row][item.labels.seat - 1].endpoint = {...item};
            if (!priceCategories.includes(item.price)) {
                priceCategories.push(item.price);
            }
        }
    });
    priceCategories.sort((a, b) => b - a);

    return (
        <>
            {children({priceCategories, map})}
        </>
    )
};

export const SectorMap = ({sectorName, children}) => {
    const SectorComponent = SECTORS[sectorName];
    return (
        <SectorComponent>
            {({map}) => 
                <>
                    {children({map})}
                </>
            }
        </SectorComponent>
    )
};

export default React.memo(SectorSeatMap);